import http from '@/plugins/axios';

export default {
  getReviewRequestsDatatables: (
    { rowsPerPage, sortBy, descending, page, search, onlyWithCoupons },
    filterBy
  ) => {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy,
      only_with_coupons: onlyWithCoupons,
      order_direction: descending ? 'desc' : 'asc',
      search,
      filter_by: JSON.stringify(filterBy),
    };
    return http
      .get('/review-requests/datatables', {
        params,
      })
      .then(res => res.data);
  },
  sendNow: (reviewRequestId, sendSms) => {
    return http.post(`/review-requests/${reviewRequestId}/send-now`, {
      sendSms,
    });
  },
  cancel: reviewRequestId => {
    return http.post(`/review-requests/${reviewRequestId}/cancel`);
  },
  reschedule: reviewRequestId => {
    return http.post(`/review-requests/${reviewRequestId}/reschedule`);
  },
  getReviewRequestsPerMonth: () => {
    return http.get('/review-requests-per-month').then(response => {
      return response.data;
    });
  },
  sendReviewRequestsByMonth: ({ year, months }) => {
    const params = {
      year,
      months,
    };
    return http.post('/schedule-review-requests-by-month', params);
  },
  scheduleReviewRequestForOrder: orderId => {
    return http.post(`/orders/${orderId}/schedule_review_request`);
  },
  calculateMaxSliderIndex: (left, collection) => {
    let sum = 0;
    let maxSliderPointerIndex = 0;
    collection.some(({ value }, index) => {
      maxSliderPointerIndex = index;
      if (sum + value > left) {
        return true;
      }
      sum += value;
    }, maxSliderPointerIndex);
    return maxSliderPointerIndex === 0 ? 0 : maxSliderPointerIndex + 1;
  },
  createLookUpTable: collection => {
    const lookUpTable = [];
    lookUpTable.length = collection.length;
    lookUpTable.fill(0);
    let sum = 0;
    for (let i = 0; i < collection.length; i++) {
      sum += collection[i].value;
      lookUpTable[i] = sum;
    }
    return lookUpTable;
  },
  scheduleLastMonth: () => {
    return http.post('/schedule-review-requests-for-last-month', {}).then(resp => resp.data);
  },
  getNumRequestsForLastMont: () =>
    http.get('/get-num-requests-for-last-month').then(res => res.data),
};
